import { render, staticRenderFns } from "./brick_aggregation_subcomponent_relation_edition.vue?vue&type=template&id=0c705bad&scoped=true&"
import script from "./brick_aggregation_subcomponent_relation_edition.vue?vue&type=script&lang=js&"
export * from "./brick_aggregation_subcomponent_relation_edition.vue?vue&type=script&lang=js&"
import style0 from "./brick_aggregation_subcomponent_relation_edition.vue?vue&type=style&index=0&id=0c705bad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c705bad",
  null
  
)

/* custom blocks */
import block0 from "./brick_aggregation_subcomponent_relation_edition.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports